export const setNoScroll = () => {
  const isMobile = $(window).width() < 768;

  if (isMobile) {
    $('body').addClass('q-no-scroll');
  }
};

export const removeNoScroll = () => {
  const hasNoScrollClass = $('body').hasClass('q-no-scroll');

  if (hasNoScrollClass) {
    $('body').removeClass('q-no-scroll');
  }
};
